"use client";

import { ArrowRight } from "iconsax-reactjs";
import { Button } from "@/components/ui/button";
import { useGoBack } from "@/hooks/useGoBack";
import { cn } from "@/lib/utils";

interface BackButtonHeaderProps {
  title: string;
  onClick?: () => void;
  href?: string;
  className?: string;
  showBorder?: boolean;
  borderColor?: "subtle" | "light";
  titleInsideButton?: boolean;
}

export const BackButtonHeader = ({
  title,
  onClick,
  href,
  className,
  showBorder = false,
  borderColor = "subtle",
  titleInsideButton = false,
}: BackButtonHeaderProps) => {
  // `href` is the FALLBACK destination (used only when there's no history to
  // pop, e.g. a direct visit) — not the primary action. Clicking always tries
  // to return the user to the real previous page first.
  const goBack = useGoBack(href);
  const handleClick = onClick ?? goBack;

  const borderClass = showBorder
    ? borderColor === "light"
      ? "border-b-3 border-stroke-light"
      : "border-b-3 border-stroke-subtle"
    : "";

  if (titleInsideButton) {
    return (
      <div className={cn("w-full", borderClass, className)}>
        <Button
          className="p-0"
          variant="light"
          startIcon={<ArrowRight size={20} />}
          onClick={handleClick}
        >
          {title}
        </Button>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2", borderClass, className)}>
      <Button className="p-0" variant="light" size="icon" onClick={handleClick}>
        <ArrowRight size={20} />
      </Button>
      <h3 className="text-base font-semibold">{title}</h3>
    </div>
  );
};
